import { useState, useEffect } from "react";
import { enumUtil } from '../../../utils/Enum';
import NotificationHandler from '../../../utils/NotificationHandler';
import { ServerRequestProtected, ServerRequestPublic } from '../../../utils/ServerDataRequest';
import { saveAs } from "file-saver";
import isNull from '../../../utils/NullChecking';
import FormValidator from '../../../utils/FormValidator';
import Loader from "../../shared/Loader/Loader";
import DeleteConfirmatiom from '../../General/DeleteConfirmation';
import InitialLetters from '../../../utils/InitialLetters';
import { isFemale, isMale } from '../../../utils/Gender';
import { PDF, Textfile } from '../IconsComponent/icons';
import { FindFirstChild } from '../../../utils/FindMenuOption';

const Notes = ({ CheckType, nameIDR, activeNotes, ID, API_URL, TableName, type, isFollowUp }) => {
    let IsEditAllowedNotes = FindFirstChild('Miscellaneous', 'Notes')?.IsAdd

    let Note_Modal = {
        Note: "",
        NoteReply: ""
    }
    let File_Modal = {
        NoteFile: [],
        NoteReplyFile: []
    };
    let valModal = {}
    let ValidationModal = {
        NoteVal: "",
    }

    const [Name, setName] = useState("")
    // const API_URL = type === 'Claim' ? enumUtil.controller.Claim : type === 'Patient' ? enumUtil.controller.Patient : type === 'Payment' ? enumUtil.controller.Payment : '';
    const [mainNoteModal, setMainNoteModal] = useState(Note_Modal);
    const [noteSaveUpdateModal, setNoteSaveUpdateModal] = useState({});
    const [NoteValidationModal, setNoteValidationModal] = useState(ValidationModal);
    const [isLoading, setIsLoading] = useState(false);
    const [selectedFiles, setSelectedFiles] = useState(File_Modal);
    const [NoteID, setNoteID] = useState(0);
    const [newNoteSaved, setNewNoteSaved] = useState(false);
    const [del, setDel] = useState(false);
    const [delID, setDelID] = useState(false);
    const [notesData, setNotesData] = useState([]);
    const API_URL_Wasabi_Download = enumUtil.controller.Wasabi_Download;
    const [other, setOther] = useState(false);
    const [expandedItemId, setExpandedItemId] = useState([]);
    const [NotesID, setNotesID] = useState(0);
    const [reply, setReply] = useState(false);
    const [PatientNotesID, setPatientNotesID] = useState(null);
    const [isEditing, setIsEditing] = useState(false);
    const [isEdited, setisEdied] = useState(false);
    const [currentNote, setCurrentNote] = useState('');
    const [previousNote, setPreviousNote] = useState('');
    const otherMsg = (item) => {
        let itemId = item[ID];
        if (expandedItemId.includes(itemId)) {
            setExpandedItemId(expandedItemId?.filter((_itemId) => _itemId !== itemId))

        }
        else {
            setExpandedItemId([...expandedItemId, itemId])
        }
        // setExpandedItemId(itemId);
        setOther(!other);
    };

    const NoteValidation = async () => {
        let ValidationModal = {
            NoteVal: FormValidator(
                mainNoteModal.Note,
                enumUtil.enumValidationType.Required,
                'Note',
            )
        }
        await setNoteValidationModal(ValidationModal)
        valModal = ValidationModal
    }

    const ReplyNoteValidation = async () => {
        let ValidationModal = {
            ReplyNoteVal: FormValidator(
                mainNoteModal.NoteReply,
                enumUtil.enumValidationType.Required,
                'Reply Note',
            )
        }
        await setNoteValidationModal(ValidationModal)
        valModal = ValidationModal
    }

    const LoadData = () => {
        setNotesData([]);
        setIsLoading(true);
        ServerRequestProtected(API_URL + '/FindbySingleCriteria', 'post', {
            "ID": nameIDR,
            "TableName": TableName,
            "Value": CheckType,
            "SearchParam": ""
        })
            .then((response) => {
                setIsLoading(false);
                setNotesData(response.Rows)
                setMainNoteModal(response.Rows)
                if (response.Rows.length > 0) {
                    const note = response.Rows[0].Note; // Adjust this as needed
                    setPreviousNote(note);
                    setNoteSaveUpdateModal({ ...noteSaveUpdateModal, Note: note });
                    console.log('Previou', previousNote)
                }
            }).catch((error) => {
                setIsLoading(false);
            })
    }
    const [Files, setFiles] = useState([]);

    const handleFileChange = (event) => {
        let { name, files } = event.target;

        setSelectedFiles({ ...selectedFiles, [name]: Array.from(files) });
        console.log(name.files, 'files and name ');

        const file = files[0];
        if (file) {
            const reader = new FileReader();
            reader.onload = (event) => {
                setNoteSaveUpdateModal({ ...noteSaveUpdateModal, [`${name}base64`]: event.target.result.split("base64,")[1] })
            };
            reader.readAsDataURL(file);
        };
    };

    // console.log(Files, 'Files ');
    const [inputKey, setInputKey] = useState(Date.now());
    const handleNoteChange = (e) => {
        let { name, value } = e.target;
        let modal = { ...mainNoteModal };
        let saveModal = { ...noteSaveUpdateModal }
        modal[name] = value
        setMainNoteModal(modal)
        for (var property in modal) {
            if (name === property) {
                saveModal[name] = value
            }
        }
        setNoteSaveUpdateModal(saveModal)
    }

    const handleSaveNote = async (NoteReply, ParentID) => {
        if (IsEditAllowedNotes) {
            NoteReply !== "NoteReply" ? await NoteValidation() : await ReplyNoteValidation();
            let validation = FormValidator([valModal], enumUtil.enumValidationType.NullCheck)
            if (validation) {
                // || selectedFiles?.NoteFile[0]?.name !== '' || selectedFiles?.NoteReplyFile[0]?.name !== ''
                NotificationHandler('Fill Required Fields', enumUtil.enumtoaster.error)
                return
            } else {
                let modalNote = {
                    TableName: TableName,
                    ID: NoteID + "",
                    data: {
                        Note: noteSaveUpdateModal.Note,
                        ...(type === 'Claim' && { FollowUp: isFollowUp + "" }),
                        ...(noteSaveUpdateModal.NoteFilebase64 && noteSaveUpdateModal.NoteFilebase64 !== "" && {
                            NoteFile: noteSaveUpdateModal.NoteFilebase64
                        }),
                        FileName: selectedFiles?.NoteFile[0]?.name,

                        // FileName: selectedFiles?.NoteFile[0]?.name,
                        // NoteFile: noteSaveUpdateModal.NoteFilebase64
                    },
                    value: null
                }
                console.log("ParentIDBefore", ParentID, ID, PatientNotesID, isFollowUp)
                let modalReplyNote = {
                    TableName: TableName,
                    ID: "0",
                    data: {
                        Note: noteSaveUpdateModal.NoteReply,
                        ...(type === 'Claim' && { FollowUp: isFollowUp + "" }),
                        ...(noteSaveUpdateModal.NoteReplyFilebase64 && noteSaveUpdateModal.NoteReplyFilebase64 !== "" && {
                            NoteFile: noteSaveUpdateModal.NoteReplyFilebase64
                        }),
                        FileName: selectedFiles?.NoteReplyFile[0]?.name,

                        // FileName: selectedFiles?.NoteReplyFile[0]?.name,
                        // NoteFile: noteSaveUpdateModal.NoteReplyFilebase64,
                        [ID]: PatientNotesID,
                    }
                }
                console.log("ParentIDAfter", ParentID, ID, PatientNotesID, modalReplyNote)
                let saveModal;
                let endPoint;
                if (NoteReply === "NoteReply") {
                    saveModal = modalReplyNote;
                } else {
                    saveModal = modalNote;
                }
                if (type === "Claim") {
                    saveModal.data['ClaimID'] = nameIDR;
                    endPoint = "/SaveSingleRecord";
                }
                if (type === "Patient") {
                    saveModal.data['PatientID'] = nameIDR;
                    endPoint = "/SaveSingleRecord";
                }
                if (ID === "PaymentsNotesID") {
                    saveModal.data['PaymentHeaderID'] = nameIDR;
                    saveModal.data['PaymentType'] = CheckType;
                    endPoint = "/SavePaymentNotes";
                }
                if (type === 'Billing') {
                    console.log('nameIDR', nameIDR);
                    saveModal.data['BillingDocumentID'] = nameIDR;
                    endPoint = "/SaveBillingDocumentNotes";
                }
                if (type === 'Submission') {
                    console.log('nameIDR', nameIDR);
                    saveModal.data['EDIClaimBatchID'] = nameIDR;
                    endPoint = "/SaveSingleRecord";
                }
                const isNoteEdited = previousNote !== noteSaveUpdateModal.Note;
                if (isNoteEdited) {
                    console.log("isNoteEdited")
                }
                setIsLoading(true);
                ServerRequestProtected(API_URL + endPoint, 'post', saveModal).then((response) => {
                    if (!isNull(response.id)) {
                        setIsLoading(false)
                        NotificationHandler('Record Saved Successfully!', enumUtil.enumtoaster.success)
                        handleSetDefault()
                        setIsEditing(false)
                        setInputKey(Date.now());

                    }
                }).catch((error) => {
                    setIsLoading(false)
                    NotificationHandler(error.response.data, enumUtil.enumtoaster.error)
                })
            }
        }
    }
    const AddNote = (item, Note, filename) => {
        console.log("Test here ")
        console.log("Isediting")
        if (item[ID] != NoteID) {
            setMainNoteModal({ ...Note_Modal, Note: Note })
            setNoteSaveUpdateModal({ ...Note_Modal, Note: Note })

            if (filename) { setSelectedFiles({ ...selectedFiles, NoteFile: [{ name: filename }] }) }
            else { setSelectedFiles({ ...selectedFiles, NoteFile: [] }) }
        }
        console.log("item[ID]", item, ID, item[ID])
        setReply(false);
        setNoteID(item[ID])
    }

    // const AddNoteEdit = (item, Note, filename,) => {
    //     setIsEditing(true);
    //     // setisEdied(true)
    //     console.log("Isediting", item)
    //     console.log("Item.recordId", item.Name)
    //     if (item[ID] != NoteID) {
    //         setMainNoteModal({ ...Note_Modal, Note: Note })
    //         setNoteSaveUpdateModal({ ...Note_Modal, Note: Note })

    //         if (filename) { setSelectedFiles({ ...selectedFiles, NoteFile: [{ name: filename }] }) }
    //         else { setSelectedFiles({ ...selectedFiles, NoteFile: [] }) }
    //     }
    //     setReply(false);
    //     setNoteID(item[ID])
    //     // setPatientNotesID(id[ID])
    //     setName(item.Name);
    // }
    const AddNoteEdit = (item, Note, filename) => {
        setIsEditing(true);
        setMainNoteModal({ ...Note_Modal, Note: Note });
        setNoteSaveUpdateModal({ ...Note_Modal, Note: Note });

        if (filename) {
            setSelectedFiles({ ...selectedFiles, NoteFile: [{ name: filename }] });
        } else {
            setSelectedFiles({ ...selectedFiles, NoteFile: [] });
        }
        setReply(false);
        setNoteID(item[ID]);
        setName(item.Name);
    }
    const handleSetDefault = () => {
        setNoteID(0);
        setMainNoteModal(Note_Modal);
        setNoteSaveUpdateModal(Note_Modal);
        setSelectedFiles(File_Modal);
        setNewNoteSaved(!newNoteSaved);
        setNotesID(0);
        setName('');
        setReply(false);
    }
    const handleClose = () => {
        if (isEditing) {
            setIsEditing(false)
            handleSetDefault()

        }
    }
    const handleRemove = (index, name, e) => {
        e.stopPropagation();
        const updatedFiles = [...selectedFiles[name]];
        updatedFiles.splice(index, 1);
        setSelectedFiles({ ...selectedFiles, [name]: updatedFiles });
        setInputKey(Date.now());
        if (name === 'NoteFile') {
            setNoteSaveUpdateModal({ ...noteSaveUpdateModal, NoteFilebase64: '' })
        }
        else if (name === 'NoteReplyFile') {
            setNoteSaveUpdateModal({ ...noteSaveUpdateModal, NoteReplyFilebase64: '' })
        }
    }

    const handleKey = (e, NoteReply, ParentID) => {

        if (e.key === 'Enter' && !e.shiftKey) {
            e.preventDefault();
            console.log("PARENT ID NOTES", NoteReply, ParentID)
            NoteReply === "NoteReply" ? handleSaveNote(NoteReply, ParentID) : handleSaveNote();
        }
        else if (e.key === 'Enter' && e.shiftKey) {
            handleNoteChange(e);
        }
    }
    const handleDelete = (id) => {
        setDelID(id)
        setDel(!del)
    }

    const handleDownloadFile = (FilePath, item) => {
        console.log('object', FilePath, item)
        setIsLoading(true)
        ServerRequestPublic(API_URL_Wasabi_Download, 'post', {
            "BucketPath": FilePath
        }, "Download")
            .then((response) => {
                setIsLoading(false)
                let blob = new Blob([response]);
                saveAs(blob, FilePath.split("/").pop());
            }).catch((error) => {
                setIsLoading(false)
                NotificationHandler(error.response.data, enumUtil.enumtoaster.error);
            })
    }
    const onCloseDelete = () => {
        setDel(false);
    }
    const isSubmissionType = type === 'Submission' || type === 'Billing';
    let DeleteConfirmations = '';
    if (del) {
        DeleteConfirmations = <DeleteConfirmatiom isOpenAlert={del} onCloseDelete={onCloseDelete} API_URL={API_URL} TableName={TableName} ID={delID} onClose={handleSetDefault} />
    }
    // const [showReply,setShowReply] =useState(false)
    const getid = (id, name) => {
        debugger
        console.log('IDIDID', id)
        setPatientNotesID(id[ID])
        // setShowReply(!showReply)
        setNotesID(id);
        setReply(!reply);
        if (reply === false) {
            setName(name);
        }
        else {
            setName('')
        }
    }
    useEffect(() => {
        if (activeNotes) {
            LoadData();
        }
    }, [activeNotes])

    useEffect(() => {
        activeNotes && nameIDR && LoadData();
    }, [newNoteSaved])
    const [isHoverScrollbar, setIsHoverScrollbar] = useState(true);

    const handleMouseEnter = () => {
        setIsHoverScrollbar(false);
    };

    const handleMouseLeave = () => {
        setIsHoverScrollbar(true);
    };
    return (
        <div>
            {isLoading ? <Loader /> : null}
            {DeleteConfirmations}
            <div className="patient_notes_content notes_view">
                <div className={`ar-notes-content ${isHoverScrollbar ? 'hover-scrollbar' : 'Remove-scroll'}`}>
                    {notesData.map((item) => {
                        let replyData = notesData.filter(items => {
                            // if (type === 'Payment') {
                            return items.ParentID === item[ID];
                            // }
                            // if (type === 'Claim') {
                            //     return items.ParentID === item.ClaimNotesID;
                            // }
                            // if (type === 'Patient') {
                            //     return items.ParentID === item.PatientNotesID;
                            // }
                        })
                        if (!item.ParentID)
                            return (
                                <div className="notes-content__item">
                                    <div className="notes-content__item__CommentBox pt-2 px-10">
                                        <div className="d-flex gap-2 align-items-center w-100">
                                            <div className="img-container s-30 circle">
                                                {item.ProfilePictureURL ? <img src={item.ProfilePictureURL}></img> :
                                                    <p className={`align-items-center d-flex h-100 heading justify-content-center w-100 fs-14 text-white ${isMale(item.Name) ? 'za-male' : isFemale(item.Name) ? 'za-female' : 'za-others'}`}>
                                                        <InitialLetters classes={""} name={item.Name} splitBy={','} />
                                                    </p>}
                                            </div>
                                            <div className="comment w-100">
                                                <div className="comment-head">
                                                    <div className="w-100">
                                                        <div className="d-flex align-items-center justify-content-between w-100">
                                                            <p className='heading'>{item.Name}</p>
                                                            {/* <div className="text ar-light-color">
                                                                {item.Edit === "True" ? "Edited" : convertTimeToHMS(new Date(item.EnteredDate), 'single')}
                                                            </div> */}
                                                            <div className="comment-body__btns">
                                                                <button className="btn-icon-transparent">
                                                                    <i className="icon-edit-pencil" onClick={() => AddNoteEdit(item, item.Note, item.NotesFilePath.split("/").pop())}></i>
                                                                </button>
                                                                <button className="btn-icon-transparent">
                                                                    <i className="icon-delete" onClick={() => handleDelete(item.RecordID)}></i>
                                                                </button>
                                                            </div>
                                                        </div>
                                                        <div className='d-flex align-items-center gap-2'>
                                                            <p className='fs-11 text ar-light-color'>  {item.Edit === 'False' ? item.EnteredDate : 'Edited ' + item.EnteredDate}</p>
                                                            <p className='fs-11 text ar-light-color time d-flex align-items-center'>{item.EnteredTime}</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="comment-body mt-2">
                                            <div>
                                                <div className='d-flex gap-2'>
                                                    <div className="notes-status-width">
                                                        <p className={`${item.PaymentType ? "notes-status heading ar-status-clm text-nowrap validation_message d-block w-100" : "d-none"}`} title={item.PaymentType}>{item.PaymentType}</p>
                                                    </div>
                                                    <p className='comment-text m-0 text'>
                                                        {item.Note && item.Note.split('\n').map((line, index) => (
                                                            <span key={index}>
                                                                {'   ' + line}
                                                                {index < item.Note.split('\n').length && <br />}
                                                            </span>))}</p>
                                                </div>
                                                {item.NotesFilePath && item.NotesFilePath.toLowerCase().endsWith('.jpeg') || item.NotesFilePath && item.NotesFilePath.toLowerCase().endsWith('.png') || item.NotesFilePath && item.NotesFilePath.toLowerCase().endsWith('.jpg')
                                                    || item.NotesFilePath && item.NotesFilePath.toLowerCase().endsWith('.JPG') || item.NotesFilePath && item.NotesFilePath.toLowerCase().endsWith('.JPEG') || item.NotesFilePath && item.NotesFilePath.toLowerCase().endsWith('.PNG') ? (
                                                    <div className="ar-filetype-ind ">
                                                        <div className='d-flex align-items-center gap-2'>
                                                            <i className='icon-image fs-22'></i>
                                                            <div>
                                                                <p className="text fs-13 font-m" onClick={() => handleDownloadFile(item.NotesFilePath, item)}>{item.NotesFilePath.split("/").pop()}</p>
                                                                <div className='d-flex align-items-center gap-40'>
                                                                    {/* <p className='text fs-10 ar-light-text fs-11 '>18Mb</p> */}
                                                                    <p className='text fs-10 ar-light-text fs-11'>PNG</p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                ) : item.NotesFilePath && item.NotesFilePath.toLowerCase().endsWith('.pdf') || item.NotesFilePath && item.NotesFilePath.toLowerCase().endsWith('.PDF') ? (
                                                    <div className="ar-filetype-ind ">
                                                        <div className='d-flex align-items-center gap-2'>
                                                            <PDF />
                                                            <div>
                                                                <p className="text fs-13 font-m" onClick={() => handleDownloadFile(item.NotesFilePath, item)}>{item.NotesFilePath.split("/").pop()}</p>
                                                                <div className='d-flex align-items-center gap-40'>
                                                                    {/* <p className='text fs-10 ar-light-text fs-11 '>18Mb</p> */}
                                                                    <p className='text fs-10 ar-light-text fs-11'>PDF</p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                ) : item.NotesFilePath && (item.NotesFilePath.toLowerCase().endsWith('.docx') || item.NotesFilePath.toLowerCase().endsWith('.doc')) || item.NotesFilePath.toLowerCase().endsWith('.DOC') || item.NotesFilePath.toLowerCase().endsWith('.DOCX') ? (
                                                    <div className="ar-filetype-ind ">
                                                        <div className='d-flex align-items-center gap-2'>
                                                            <span class="icon-word fs-21"><span class="path1"></span><span class="path2"></span><span class="path3"></span></span>
                                                            <div>
                                                                <p className="text fs-13 font-m" onClick={() => handleDownloadFile(item.NotesFilePath, item)}>{item.NotesFilePath.split("/").pop()}</p>
                                                                <div className='d-flex align-items-center gap-40'>
                                                                    {/* <p className='text fs-10 ar-light-text fs-11 '>18Mb</p> */}
                                                                    <p className='text fs-10 ar-light-text fs-11'>Word</p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                ) : item.NotesFilePath && (item.NotesFilePath.toLowerCase().endsWith('.xls') || item.NotesFilePath.toLowerCase().endsWith('.xlsx')) || item.NotesFilePath && (item.NotesFilePath.toLowerCase().endsWith('.XLS')) || item.NotesFilePath && (item.NotesFilePath.toLowerCase().endsWith('.XLSX')) ? (
                                                    <div className="ar-filetype-ind ">
                                                        <div className='d-flex align-items-center gap-2'>
                                                            <i className='icon-excel fs-21 text-success'></i>
                                                            <div>
                                                                <p className="text fs-13 font-m" onClick={() => handleDownloadFile(item.NotesFilePath, item)}>{item.NotesFilePath.split("/").pop()}</p>
                                                                <div className='d-flex align-items-center gap-40'>
                                                                    {/* <p className='text fs-10 ar-light-text fs-11 '>18Mb</p> */}
                                                                    <p className='text fs-10 ar-light-text fs-11'>Excel</p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                ) : item.NotesFilePath && item.NotesFilePath.toLowerCase().endsWith('.txt') || item.NotesFilePath && item.NotesFilePath.toLowerCase().endsWith('.TXT') ? (
                                                    <div className="ar-filetype-ind ">
                                                        <div className='d-flex align-items-center gap-2'>
                                                            <Textfile />
                                                            <div>
                                                                <p className="text fs-13 font-m" onClick={() => handleDownloadFile(item.NotesFilePath, item)}>{item.NotesFilePath.split("/").pop()}</p>
                                                                <div className='d-flex align-items-center gap-40'>
                                                                    {/* <p className='text fs-10 ar-light-text fs-11 '>18Mb</p> */}
                                                                    <p className='text fs-10 ar-light-text fs-11'>Text</p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )
                                                    : item.NotesFilePath && <div className="ar-filetype-ind ">
                                                        <div className='d-flex align-items-center gap-2'>
                                                            {/* <i className='icon-excel fs-21 text-success'></i> */}
                                                            <div>
                                                                <p className="text fs-13 font-m" onClick={() => handleDownloadFile(item.NotesFilePath, item)}>{item.NotesFilePath.split("/").pop()}</p>
                                                                <div className='d-flex align-items-center gap-40'>
                                                                    {/* <p className='text fs-10 ar-light-text fs-11 '>18Mb</p> */}
                                                                    <p className='text fs-10 ar-light-text fs-11'>UnKown</p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>}

                                            </div>
                                            {/* // {/ <p> <span className="heading note_btn">Audit</span> Need to add some documents   </p> /} */}

                                            {/* <div className="d-flex align-items-baseline mt-1 justify-content-end">
                                                <div className="comment-body__btns">
                                                    <button className="btn-icon-transparent">
                                                        <i className="icon-edit-pencil" onClick={() => AddNoteEdit(item, item.Note, item.Name, item.NotesFilePath.split("/").pop())}></i>
                                                    </button>
                                                    <button className="btn-icon-transparent">
                                                        <i className="icon-delete" onClick={() => handleDelete(item.RecordID)}></i>
                                                    </button>
                                                </div>
                                            </div> */}
                                        </div>
                                    </div>
                                    <div className='px-10 mt-1 d-flex align-items-center gap-25 mb-2'>
                                        <div className='d-flex align-items-center gap-2 cursor-pointer' onClick={() => getid(item, item.Name)}>
                                            <i className='icon-Page-11 fs-15'></i>
                                            <p className='fs-11 text ar-light-color'>Reply</p>
                                        </div>
                                        {item?.Replycount > 0 ?

                                            <div className='d-flex align-items-center gap-2 cursor-pointer'>
                                                <span class="icon-Group-1000002693 fs-14"><span class="path1"></span><span class="path2"></span></span>
                                                {expandedItemId.includes(item[ID]) === true ? <p className='fs-11 text ar-light-color d-flex align-items-center gap-1' onClick={() => otherMsg(item)}>Hide Replies
                                                    <span
                                                        className={`align-items-center d-flex font-m fs-10 heading justify-content-center text-white ${item.Replycount > 0 ? 'ar_counter' : ''}`}>
                                                        {item.Replycount}
                                                    </span>
                                                </p> :

                                                    <p className='fs-11 text ar-light-color d-flex align-items-center gap-1' onClick={() => otherMsg(item)}>View replies
                                                        <span
                                                            className={`align-items-center d-flex font-m fs-10 heading justify-content-center text-white ${item.Replycount > 0 ? 'ar_counter' : ''}`}>
                                                            {item.Replycount}
                                                        </span>
                                                    </p>


                                                }
                                            </div>
                                            : null}
                                        {/* <div className='d-flex align-items-center gap-2 cursor-pointer'>
                                            <span class="icon-Group-1000002693 fs-14"><span class="path1"></span><span class="path2"></span></span>
                                            {expandedItemId.includes(item[ID]) === true ? <p className='fs-11 text ar-light-color d-flex align-items-center gap-1' onClick={() => otherMsg(item)}>Hide Replies
                                                <span
                                                    className={`align-items-center d-flex font-m fs-10 heading justify-content-center text-white ${item.Replycount > 0 ? 'ar_counter' : ''}`}>
                                                    {item.Replycount}
                                                </span>
                                            </p> :
                                            
                                                <p className='fs-11 text ar-light-color d-flex align-items-center gap-1' onClick={() => otherMsg(item)}>View replies
                                                    <span
                                                        className={`align-items-center d-flex font-m fs-10 heading justify-content-center text-white ${item.Replycount > 0 ? 'ar_counter' : ''}`}>
                                                        {item.Replycount}
                                                    </span>
                                                </p>
                                                
                                                
                                                }
                                        </div> */}
                                    </div>
                                    {
                                        expandedItemId.includes(item[ID]) && (
                                            <>
                                                <div className='ar-reply-content hover-scrollbar' onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
                                                    {replyData.length !== 0 && replyData?.map((value) => {
                                                        return (<>
                                                            <div className="notes-content__item">
                                                                <div className="notes-content__item__CommentBox pt-2 px-10">
                                                                    <div className="d-flex gap-2 align-items-center w-100">
                                                                        <div className="img-container s-30 circle">
                                                                            {value.ProfilePictureURL ? <img src={value.ProfilePictureURL}></img> :
                                                                                <p className={`align-items-center d-flex h-100 heading justify-content-center w-100 fs-14 text-white ${isMale(item.Name) ? 'za-male' : isFemale(item.Name) ? 'za-female' : 'za-others'}`}>
                                                                                    <InitialLetters classes={""} name={item.Name} splitBy={','} />
                                                                                </p>}
                                                                        </div>
                                                                        <div className="comment w-100">
                                                                            <div className="comment-head">
                                                                                <div className="w-100">
                                                                                    <div className="d-flex align-items-center justify-content-between w-100">
                                                                                        <div className="heading">{value.Name}</div>
                                                                                        {/* <div className="text ar-light-color">
                                                                                                    {convertTimeToHMS(new Date(value.EnteredDate), 'single')}
                                                                                                </div> */}
                                                                                        <div className="comment-body__btns">
                                                                                            <button className="btn-icon-transparent">
                                                                                                <i className="icon-edit-pencil" onClick={() => AddNote(value, value.Note, value.NotesFilePath.split("/").pop())}></i>
                                                                                            </button>
                                                                                            <button className="btn-icon-transparent">
                                                                                                <i className="icon-delete" onClick={() => handleDelete(value.RecordID)}></i>
                                                                                            </button>
                                                                                        </div>
                                                                                    </div>
                                                                                    <div className='d-flex align-items-center gap-2'>
                                                                                        <p className='fs-11 text ar-light-color'>{value.Edit === 'False' ? value.EnteredDate : 'Edited ' + value.EnteredDate}</p>
                                                                                        <p className='fs-11 text ar-light-color time d-flex align-items-center'>{value.EnteredTime}</p>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div className="comment-body mt-2">
                                                                        <div>
                                                                            <div className='d-flex gap-2'>
                                                                                <p className='comment-text m-0 text'>
                                                                                    {value.Note && value.Note.split('\n').map((line, index) => (
                                                                                        <span key={index}>
                                                                                            {'   ' + line}
                                                                                            {index < value.Note.split('\n').length && <br />}
                                                                                        </span>))}</p>
                                                                            </div>
                                                                            {value.NotesFilePath && value.NotesFilePath.toLowerCase().endsWith('.png') || value.NotesFilePath && value.NotesFilePath.toLowerCase().endsWith('.PNG') || value.NotesFilePath && value.NotesFilePath.toLowerCase().endsWith('.jpg')
                                                                                || value.NotesFilePath && value.NotesFilePath.toLowerCase().endsWith('.JPG') || value.NotesFilePath && value.NotesFilePath.toLowerCase().endsWith('.jpeg') || value.NotesFilePath && value.NotesFilePath.toLowerCase().endsWith('.JPEG') ? (
                                                                                <div className="ar-filetype-ind ">
                                                                                    <div className='d-flex align-items-center gap-2'>
                                                                                        <i className='icon-image fs-22'></i>
                                                                                        <div>
                                                                                            <p className="text fs-13 font-m" onClick={() => handleDownloadFile(value.NotesFilePath, value)}>{value.NotesFilePath.split("/").pop()}</p>
                                                                                            <div className='d-flex align-items-center gap-40'>
                                                                                                {/* <p className='text fs-10 ar-light-text fs-11 '>18Mb</p> */}
                                                                                                <p className='text fs-10 ar-light-text fs-11'>PNG</p>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            ) : value.NotesFilePath && value.NotesFilePath.toLowerCase().endsWith('.pdf') || value.NotesFilePath && value.NotesFilePath.toLowerCase().endsWith('.PDF') ? (
                                                                                <div className="ar-filetype-ind ">
                                                                                    <div className='d-flex align-items-center gap-2'>
                                                                                        <PDF />
                                                                                        <div>
                                                                                            <p className="text fs-13 font-m" onClick={() => handleDownloadFile(value.NotesFilePath, value)}>{value.NotesFilePath.split("/").pop()}</p>
                                                                                            <div className='d-flex align-items-center gap-40'>
                                                                                                {/* <p className='text fs-10 ar-light-text fs-11 '>18Mb</p> */}
                                                                                                <p className='text fs-10 ar-light-text fs-11'>PDF</p>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            ) : value.NotesFilePath && value.NotesFilePath.toLowerCase().endsWith('.docx') || value.NotesFilePath && value.NotesFilePath.endsWith('.doc') || value.NotesFilePath && value.NotesFilePath.toLowerCase().endsWith('.DOCX') || value.NotesFilePath && value.NotesFilePath.endsWith('.DOC') ? (
                                                                                <div className="ar-filetype-ind ">
                                                                                    <div className='d-flex align-items-center gap-2'>
                                                                                        <span class="icon-word fs-21"><span class="path1"></span><span class="path2"></span><span class="path3"></span></span>
                                                                                        <div>
                                                                                            <p className="text fs-13 font-m" onClick={() => handleDownloadFile(value.NotesFilePath, value)}>{value.NotesFilePath.split("/").pop()}</p>
                                                                                            <div className='d-flex align-items-center gap-40'>
                                                                                                {/* <p className='text fs-10 ar-light-text fs-11 '>18Mb</p> */}
                                                                                                <p className='text fs-10 ar-light-text fs-11'>Word</p>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            ) : value.NotesFilePath && value.NotesFilePath.toLowerCase().endsWith('.xls') || value.NotesFilePath && value.NotesFilePath.endsWith('.xlsx') || value.NotesFilePath && value.NotesFilePath.toLowerCase().endsWith('.XLS') || value.NotesFilePath && value.NotesFilePath.toLowerCase().endsWith('.XLSX') ? (
                                                                                <div className="ar-filetype-ind ">
                                                                                    <div className='d-flex align-items-center gap-2'>
                                                                                        <i className='icon-excel fs-21 text-success'></i>
                                                                                        <div>
                                                                                            <p className="text fs-13 font-m" onClick={() => handleDownloadFile(value.NotesFilePath, value)}>{value.NotesFilePath.split("/").pop()}</p>
                                                                                            <div className='d-flex align-items-center gap-40'>
                                                                                                {/* <p className='text fs-10 ar-light-text fs-11 '>18Mb</p> */}
                                                                                                <p className='text fs-10 ar-light-text fs-11'>Execl</p>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            ) : value.NotesFilePath && value.NotesFilePath.toLowerCase().endsWith('.txt') || value.NotesFilePath && value.NotesFilePath.toLowerCase().endsWith('.TXT') ? (
                                                                                <div className="ar-filetype-ind ">
                                                                                    <div className='d-flex align-items-center gap-2'>
                                                                                        <Textfile />
                                                                                        <div>
                                                                                            <p className="text fs-13 font-m" onClick={() => handleDownloadFile(value.NotesFilePath, value)}>{value.NotesFilePath.split("/").pop()}</p>
                                                                                            <div className='d-flex align-items-center gap-40'>
                                                                                                {/* <p className='text fs-10 ar-light-text fs-11 '>18Mb</p> */}
                                                                                                <p className='text fs-10 ar-light-text fs-11'>Text</p>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            )

                                                                                : value.NotesFilePath && (
                                                                                    <div className="ar-filetype-ind ">
                                                                                        <div className='d-flex align-items-center gap-2'>
                                                                                            <div>
                                                                                                <p className="text fs-13 font-m" onClick={() => handleDownloadFile(value.NotesFilePath, value)}>{value.NotesFilePath.split("/").pop()}</p>
                                                                                                <div className='d-flex align-items-center gap-40'>
                                                                                                    <p className='text fs-10 ar-light-text fs-11'>Unknow</p>
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>)}
                                                                        </div>

                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </>)
                                                    })
                                                    }
                                                </div>
                                            </>
                                        )
                                    }
                                </div>)
                    })}
                </div>

                {
                    reply ?

                        <div className="notes-content__item reply_input">
                            <div className="notes-content__item__Form d-block">
                                {selectedFiles.NoteReplyFile?.map((file, index) => {
                                    const fileName = file?.name ?? file?.item?.FileName;
                                    console.log(selectedFiles.NoteReplyFile, 'file in map');
                                    const isExcel = file?.name?.toLowerCase().endsWith('.xlsx') || file?.name?.toLowerCase().endsWith('.xls') || file?.name?.endsWith('.XLS') || file?.name?.endsWith('.XLSX');
                                    const isImage = file?.name?.endsWith('.jpg') || file?.name?.endsWith('.jpeg') || file?.name?.endsWith('.png') || file?.name?.endsWith('.PNG') || file?.name?.endsWith('.JPEG') || file?.name?.endsWith('.JPG');
                                    const isDoc = file?.name?.endsWith('.doc') || file?.name?.endsWith('.docx') || file?.name?.endsWith('.DOC') || file?.name?.endsWith('.DOCX');
                                    const isPDF = file?.name?.toLowerCase().endsWith('.pdf') || file?.name?.endsWith('.PDF');
                                    const isText = file?.name?.toLowerCase().endsWith('.txt') || file?.name?.endsWith('.TXT');
                                    return (
                                        <div className='ar-notes-file-upload' key={index}>
                                            <div className="d-flex align-items-center justify-content-between">
                                                <div className='d-flex gap-2 align-items-center'>

                                                    {isExcel && <i className='icon-excel fs-21 text-success'></i>}
                                                    {isPDF && <PDF />}
                                                    {isDoc && <span class="icon-word fs-21"><span class="path1"></span><span class="path2"></span><span class="path3"></span></span>}
                                                    {isImage && <i className='icon-image fs-22'></i>}
                                                    {isText && <Textfile />}
                                                    <div>
                                                        <p className="text fs-13 font-m pb-1" title={file?.name ?? file?.item?.FileName}> {file?.name ?? file?.item?.FileName} </p>
                                                        <div className='d-flex align-items-center gap-40'>
                                                            {/* <p className='text fs-10 ar-light-text fs-11 '>18Mb</p> */}

                                                            <p className='text fs-10 ar-light-text fs-11'>{isExcel ? 'Excel' : isPDF ? 'PDF' : isDoc ? 'Word ' : isImage ? 'Image' : isText ? 'Text File' : 'Unknown'}</p>
                                                        </div>
                                                    </div>
                                                </div>
                                                <i className='icon-Icon-metro-cross fs-13' onClick={(e) => handleRemove(index, 'NoteReplyFile', e)}></i>
                                            </div>
                                        </div>
                                    );
                                })}
                                <div className='position-relative me-2'>
                                    <textarea
                                        type="text"
                                        className={`text ${!isNull(Name) ? "notes-pad-left" : ""} ${NoteValidationModal.ReplyNoteVal ? 'error' : ''}`}
                                        placeholder="Reply to note"
                                        name='NoteReply'
                                        id='NoteReply'
                                        value={mainNoteModal.NoteReply}
                                        onKeyDown={(e) => handleKey(e, "NoteReply", NotesID)}
                                        onChange={handleNoteChange}
                                    />
                                    <button className="btn-icon-transparent attach-Btn">
                                        <i className="icon-Icon-metro-attachment"></i>
                                        {/* handle file change */}
                                        <input
                                            key={inputKey}
                                            type="file"
                                            name='NoteReplyFile'
                                            id='NoteReplyFile'
                                            className='m-0 p-0'
                                            onChange={handleFileChange}
                                        />
                                    </button>
                                    <button className={IsEditAllowedNotes ? "btn-icon-transparent Round-Btn" : "btn-icon-transparent Round-Btn disabled"} onClick={() => handleSaveNote("NoteReply", NotesID)}>
                                        <i className="icon-arrow-right2"></i>
                                    </button>
                                    <p className="xsm_text replyer_name" hidden={Name === ''}>{Name} </p>
                                    {console.log('Name Reply', Name)}
                                </div>
                            </div>
                            {/* <div className="filetype-ind">
                                {selectedFiles.NoteReplyFile.length > 0 &&
                                    selectedFiles.NoteReplyFile.map((file, index) => (
                                        <React.Fragment key={index}>
                                            <span>{file.name}</span>
                                            <button className="btn-icon-transparent">
                                                <i className="icon-Icon-ionic-ios-remove-circle-outline" onClick={() => handleRemove(index, 'NoteReplyFile')}></i>
                                            </button>
                                        </React.Fragment>
                                    ))}
                            </div> */}
                        </div>
                        :
                        <div className="notes-content__item reply_input border-0" >
                            <div className="notes-content__item__Form d-block">

                                {selectedFiles.NoteFile?.map((file, index) => {
                                    const fileName = file?.name ?? file?.item?.FileName;
                                    fileName.split('.').pop().toLowerCase();
                                    // console.log(selectedFiles.NoteFile, 'file in map');


                                    const isExcel = file?.name?.toLowerCase().endsWith('.xlsx') || file?.name?.toLowerCase().endsWith('.xls') || file?.name?.endsWith('.XLS') || file?.name?.endsWith('.XLSX');
                                    const isImage = file?.name?.endsWith('.jpg') || file?.name?.endsWith('.jpeg') || file?.name?.endsWith('.png') || file?.name?.endsWith('.PNG') || file?.name?.endsWith('.JPEG') || file?.name?.endsWith('.JPG');
                                    const isDoc = file?.name?.endsWith('.doc') || file?.name?.endsWith('.docx') || file?.name?.endsWith('.DOC') || file?.name?.endsWith('.DOCX');
                                    const isPDF = file?.name?.toLowerCase().endsWith('.pdf') || file?.name?.endsWith('.PDF');
                                    const isText = file?.name?.toLowerCase().endsWith('.txt') || file?.name?.endsWith('.TXT');
                                    return (

                                        <div className='ar-notes-file-upload' key={index}>
                                            <div className="d-flex align-items-center justify-content-between">
                                                <div className='d-flex gap-2 align-items-center'>
                                                    {isExcel && <i className='icon-excel fs-21 text-success'></i>}
                                                    {isPDF && <PDF />}
                                                    {isDoc && <span class="icon-word fs-21"><span class="path1"></span><span class="path2"></span><span class="path3"></span></span>}
                                                    {isImage && <i className='icon-image fs-22'></i>}
                                                    {isText && <Textfile />}
                                                    <div>
                                                        <p className="text fs-13 font-m pb-1" title={file?.name ?? file?.item?.FileName}> {file?.name ?? file?.item?.FileName} </p>
                                                        <div className='d-flex align-items-center gap-40'>
                                                            {/* <p className='text fs-10 ar-light-text fs-11 '>18Mb</p> */}

                                                            <p className='text fs-10 ar-light-text fs-11'>{isExcel ? 'Excel' : isPDF ? 'PDF' : isDoc ? 'Word ' : isImage ? 'Image' : isText ? 'Text File' : 'Unknown'}</p>
                                                        </div>
                                                    </div>
                                                </div>
                                                <i className='icon-Icon-metro-cross fs-13' onClick={(e) => handleRemove(index, 'NoteFile', e)}></i>
                                            </div>
                                        </div>
                                    );
                                })}
                                <div className='position-relative me-2'>
                                    <textarea
                                        rows="4"
                                        type="text"
                                        className={`text ${NoteValidationModal.NoteVal ? 'error' : ''} ${isEditing ? 'ps-92' : ''}`}
                                        placeholder="Add new note"
                                        name='Note'
                                        id='Note'
                                        value={mainNoteModal.Note}
                                        onKeyDown={handleKey}
                                        onChange={handleNoteChange}
                                    />

                                    {/*  icons {icon-image , icon-word, icon-pdf-chatbot} show on condtion*/}

                                    {/* <button className="btn-icon-transparent attach-Btn za-img-Btn">
                                    <i className="icon-image"></i>
                                </button>
                                <button className="btn-icon-transparent attach-Btn za-word-Btn">
                                    <span class="icon-word"><span class="path1"></span><span class="path2"></span><span class="path3"></span></span>
                                </button>
                                <button className="btn-icon-transparent attach-Btn za-pdf-Btn">
                                    <span class="icon-pdf-chatbot"><span class="path1"></span><span class="path2"></span><span class="path3"></span><span class="path4"></span><span class="path5"></span><span class="path6"></span><span class="path7"></span></span>
                                </button> */}


                                    <button className="btn-icon-transparent attach-Btn m-0 p-0 " onClick={handleClose}>
                                        <div></div>
                                        <i className={isEditing ? "icon-close pt-3px" : "icon-Icon-metro-attachment"} ></i>
                                        <input
                                            key={inputKey}
                                            type={isEditing ? "text" : "file"}
                                            className='m-0 p-0'
                                            name='NoteFile'
                                            id='NoteFile'
                                            onChange={handleFileChange} />
                                    </button>
                                    <button className={IsEditAllowedNotes ? "btn-icon-transparent Round-Btn" : "btn-icon-transparent Round-Btn disabled"} onClick={handleSaveNote}>
                                        <i className="icon-arrow-right2"></i>
                                    </button>
                                    <p className="xsm_text replyer_name" hidden={Name === ''}>{Name} </p>
                                </div>
                            </div>
                            <div className="filetype-ind">
                                {/* {selectedFiles.NoteFile.length > 0 &&
                                    selectedFiles.NoteFile.map((file, index) => (
                                        <React.Fragment key={index}>
                                            <span>{file.name}</span>
                                        <button className="btn-icon-transparent">
                                            <i className="icon-Icon-ionic-ios-remove-circle-outline" onClick={() => handleRemove(index, 'NoteFile')}></i>
                                        </button>
                                        </React.Fragment>
                                    ))} */}
                            </div>
                        </div>
                }
            </div>
        </div >
    )
}

export default Notes
